export default {
  default: 'Default',
  goldenrod: 'Goldenrod',
  magenta: 'Magenta',
  violet: 'Violet',
  mint: 'Mint',
  blue: 'Blue',
  coral: 'Coral',
  slate: 'Slate',
  emerald: 'Emerald',
  indigo: 'Indigo',
  crimson: 'Crimson',
  rose: 'Rose',
  orange: 'Orange',
  amber: 'Amber'
}